import { Button, FormLabel, GridLegacy, MenuItem, Select, TextField, Typography } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { convertArrayToSelectOptions, convertObjectToSelectOptions } from "../../../templateHelpers";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import {
  activeThemes,
  autoOpenMode,
  kaartStylen,
  menuStylen,
  selectableKioskV2Languages,
  serviceAppView,
  talenV5,
} from "../../../variables/app";
import FormSelectTC from "../../../components/Forms/FormSelectTC";
import FormSwitchTC from "../../../components/Forms/FormSwitchTC";
import FormTextTC from "../../../components/Forms/FormTextTC";
import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";
import FormColorTC from "../../../components/Forms/FormColorTC";
import FormFile from "../../../components/Forms/FormFile";
import FormFieldTwoColumns from "../../../components/Forms/Layouts/FormFieldTwoColumns";
import FormSwitch from "../../../components/Forms/FormSwitch";
import AuthenticationWrapper, { AuthenticationWrapperFunctional } from "../../../auth/AuthenticationWrapper";
import { useController, useFormContext, useWatch } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import Tooltip from "@mui/material/Tooltip";
import Edit from "@mui/icons-material/Edit";
import InfoTextDialog from "./Dialogs/InfoTextDialog";
import { connect } from "react-redux";
import BrandingV5 from "./V5/BrandingV5";
import { ImageResolutionHint } from "../../../components/ImageHints/ImageResolutionHint";
import { UsingOtherSalesareaForStylingAlert } from "../../../components/UsingOtherSalesareaForStylingAlert";

const menuStylenOptions = convertArrayToSelectOptions(menuStylen);
const kaartStylenOptions = convertArrayToSelectOptions(kaartStylen);
const activeThemesOptions = convertArrayToSelectOptions(activeThemes);
const autoOpenModeOptions = convertArrayToSelectOptions(autoOpenMode);
const serviceAppViewOptions = convertArrayToSelectOptions(serviceAppView);
const selectableFrontendLanguagesOptions = convertObjectToSelectOptions(talenV5);
const selectableFrontendLanguageOptionsv2 = convertObjectToSelectOptions(selectableKioskV2Languages);

const designs = [
  {
    value: "Jamezz V3",
    themes: [
      { value: "V3- Normal", appTarget: "app.js", activeTheme: "DEFAULT", instoreScreen: 0 },
      { value: "Black", appTarget: "app.js", activeTheme: "black", instoreScreen: 0 },
      { value: "Orange", appTarget: "app.js", activeTheme: "orange", instoreScreen: 0 },
      { value: "Blauw", appTarget: "app.js", activeTheme: "blauw", instoreScreen: 0 },
      { value: "Rood", appTarget: "app.js", activeTheme: "rood", instoreScreen: 0 },
      { value: "Groen", appTarget: "app.js", activeTheme: "groen", instoreScreen: 0 },
    ],
  },
  {
    value: "Jamezz V3 Kiosk",
    themes: [
      {
        value: "V3 KIOSK_v2.0 (Normal)",
        appTarget: "app_kioskv2.js",
        activeTheme: "kioskv2boColors",
        instoreScreen: 1,
      },
      {
        value: "V3 KIOSK_v2.0 (Low res 768x1024)",
        appTarget: "app_kioskv2.js",
        activeTheme: "kioskv2boColorsRes768x1024",
        instoreScreen: 1,
      },
      {
        value: "V3 KIOSK_v1.0 (old)",
        appTarget: "app.js",
        activeTheme: "DEFAULT",
        instoreScreen: 1,
      },
      { value: "V3 KIOSK_v1.0 (old)Black", appTarget: "app.js", activeTheme: "black", instoreScreen: 1 },
      { value: "V3 KIOSK_v1.0 (old)Orange", appTarget: "app.js", activeTheme: "orange", instoreScreen: 1 },
      { value: "V3 KIOSK_v1.0 (old)Blauw", appTarget: "app.js", activeTheme: "blauw", instoreScreen: 1 },
      { value: "V3 KIOSK_v1.0 (old)Rood", appTarget: "app.js", activeTheme: "rood", instoreScreen: 1 },
      { value: "V3 KIOSK_v1.0 (old)Groen", appTarget: "app.js", activeTheme: "groen", instoreScreen: 1 },
    ],
  },
  {
    value: "Jamezz V3 Maatwerk",
    themes: [
      {
        value: "Wok To Go",
        appTarget: "app_woktogo.js",
        activeTheme: "woktogo",
        instoreScreen: 1,
      },
    ],
  },
  {
    value: "Jamezz V4",
    themes: [
      {
        value: "V4 - Normal (One page design)",
        appTarget: "app_lite.js",
        activeTheme: "DEFAULT",
        instoreScreen: 0,
      },
    ],
  },
  {
    value: "Jamezz V5",
    themes: [
      { value: "V5 QR", appTarget: "appv5.js", activeTheme: "DEFAULT", instoreScreen: 0 },
      { value: "V5 Kiosk", appTarget: "appv5.js", activeTheme: "DEFAULT", instoreScreen: 1 },
    ],
    permissionKey: "Branding.design.JamezzV5",
  },
];

function Branding(props) {
  const [infoTextDialogIsOpen, setInfoTextDialogIsOpen] = useState(false);
  //Dropdown opties

  const {
    field: { value: appTargetValue, onChange: appTargetOnChange },
  } = useController({ name: "appTarget" });
  const {
    field: { value: activeThemeValue, onChange: activeThemeOnChange },
  } = useController({ name: "activeTheme" });
  const {
    field: { value: instoreScreenValue, onChange: instoreScreenOnChange },
  } = useController({ name: "instoreScreen" });

  const initialDesign = useMemo(() => {
    let obj = null;
    designs.some((design) => {
      return design.themes.some((theme) => {
        if (
          appTargetValue === theme.appTarget &&
          activeThemeValue === theme.activeTheme &&
          instoreScreenValue === theme.instoreScreen
        ) {
          obj = { design, theme };
          return true;
        }
        return false;
      });
    });
    return obj;
  }, [appTargetValue]);

  const [design, setDesign] = useState(initialDesign?.design.value ?? "");
  const [theme, setTheme] = useState(initialDesign?.theme.value ?? "");

  useEffect(() => {
    setDesign(initialDesign?.design.value ?? "");
    setTheme(initialDesign?.theme.value ?? "");
  }, [initialDesign]);
  const themeOptions = useMemo(() => {
    let found = designs.find((des) => des.value === design);
    return found?.themes ?? [];
  }, [design]);

  const {
    setError,
    clearErrors,
    formState: { errors },
    vestigingId,
    setValue,
  } = useFormContext();

  useEffect(() => {
    if (
      !designs.some((d) => {
        if (d.value === design) {
          return d.themes.some((t) => {
            if (t.value === theme) {
              if (t.appTarget !== appTargetValue) {
                appTargetOnChange(t.appTarget);
              }
              if (t.activeTheme !== activeThemeValue) {
                activeThemeOnChange(t.activeTheme);
              }
              if (t.instoreScreen !== instoreScreenValue) {
                instoreScreenOnChange(t.instoreScreen);
              }
              clearErrors("validTheme");
              return true;
            }
            return false;
          });
        }
        return false;
      })
    ) {
      setError("validTheme", { type: "manual", message: "Valid theme required" });
    }
  }, [theme]);

  const extra_settings__infoSplashShowAlways = useWatch({ name: "extra_settings__infoSplashShowAlways" });
  const extra_settings__infoSplashButton = useWatch({ name: "extra_settings__infoSplashButton" });
  const styling_vestiging_id = useWatch({ name: "styling_vestiging_id" });

  const custom_data = useWatch({ name: "custom_data" });

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody>
          <div style={{ width: "100%" }}>
            <GridLegacy container spacing={1} style={{ maxWidth: 600, marginBottom: 32 }}>
              {styling_vestiging_id ? (
                <GridLegacy item xs={12}>
                  <UsingOtherSalesareaForStylingAlert styling_salesarea_id={styling_vestiging_id} />
                </GridLegacy>
              ) : null}
              <GridLegacy item xs={12}>
                <h3>
                  <TranslationWrapper tDefault={"Thema"} tKey={"vestigingen.form.branding.headers.thema"} />
                </h3>
              </GridLegacy>

              <FormFieldTwoColumns label={<TranslationWrapper tKey={"Design"} />}>
                <>
                  <Select
                    color={"primary"}
                    onChange={(e) => {
                      setDesign(e.target.value);
                      setTheme("");
                    }}
                    style={{ width: "100%", backgroundColor: "rgba(100, 100, 100, 0.05)" }}
                    value={design}
                  >
                    {designs.map((design) =>
                      design.permissionKey ? (
                        AuthenticationWrapperFunctional(design.permissionKey, props.user) === 3 ? (
                          <MenuItem key={design.value} value={design.value}>
                            {design.value}
                          </MenuItem>
                        ) : (
                          <MenuItem disabled={true} key={design.value} value={design.value}>
                            {design.value}
                          </MenuItem>
                        )
                      ) : (
                        <MenuItem key={design.value} value={design.value}>
                          {design.value}
                        </MenuItem>
                      )
                    )}
                  </Select>
                </>
              </FormFieldTwoColumns>

              <FormFieldTwoColumns label={<TranslationWrapper tKey={"Theme"} />}>
                <>
                  <Select
                    color={"primary"}
                    onChange={(e) => {
                      setTheme(e.target.value);
                    }}
                    style={{ width: "100%", backgroundColor: "rgba(100, 100, 100, 0.05)" }}
                    value={theme}
                  >
                    {themeOptions.map((theme) =>
                      theme.permissionKey ? (
                        <AuthenticationWrapper
                          child={
                            <MenuItem key={theme.value} value={theme.value}>
                              {theme.value}
                            </MenuItem>
                          }
                          key={theme.value}
                          permissionKey={theme.permissionKey}
                        />
                      ) : (
                        <MenuItem key={theme.value} value={theme.value}>
                          {theme.value}
                        </MenuItem>
                      )
                    )}
                  </Select>
                  <ErrorMessage
                    errors={errors}
                    name={"validTheme"}
                    render={({ messages, message }) => {
                      if (messages) {
                        return Object.entries(messages).map(([type, message]) => (
                          <Typography color={"error"} key={type}>
                            {message}
                          </Typography>
                        ));
                      } else if (message) {
                        return <Typography color={"error"}>{message}</Typography>;
                      } else {
                        return null;
                      }
                    }}
                  />
                </>
              </FormFieldTwoColumns>
              <>
                <FormSelectTC
                  name={"serviceAppView"}
                  options={serviceAppViewOptions}
                  tDefault={"Service app view"}
                  tKey={"vestigingen.form.overige.label.serviceAppView"}
                />
              </>
              <GridLegacy item lg={4} xs={12}>
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"extra_settings__infoSplashShowAlways"}
                  tDefault={"Show Info Screen Always on start"}
                  tKey={"extra_settings.fields.label.infoSplashShowAlways"}
                />
              </GridLegacy>
              <GridLegacy item lg={4} xs={12}>
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"showReview"}
                  tDefault={"Showreview"}
                  tKey={"extra_settings.fields.label.showReview"}
                />
              </GridLegacy>
              <GridLegacy item lg={4} xs={12}>
                {!!extra_settings__infoSplashButton || !!extra_settings__infoSplashShowAlways ? (
                  <Tooltip
                    placement={"bottom"}
                    title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
                  >
                    <Button
                      color={"primary"}
                      onClick={() => {
                        setInfoTextDialogIsOpen(true);
                      }}
                      variant={"contained"}
                    >
                      <Edit />
                    </Button>
                  </Tooltip>
                ) : null}
              </GridLegacy>
            </GridLegacy>
          </div>
          <GridLegacy container spacing={1} style={{ maxWidth: 600 }}>
            {!design.includes("V4") && !design.includes("V5") ? (
              <>
                <FormSelectTC name={"menuStyle"} options={menuStylenOptions} tKey={"Menu style eten"} />

                <FormSelectTC
                  name={"menuStylePCAuto"}
                  options={menuStylenOptions}
                  tDefault={"Menu style eten (PC/A)"}
                  tKey={"vestigingen.form.overige.label.menuStylePCAuto"}
                />
              </>
            ) : null}
            {!design.includes("V5") ? (
              <FormSelectTC
                name={"extra_settings__kaartStyle"}
                options={kaartStylenOptions}
                tKey={"Menu style kaart"}
              />
            ) : null}

            {!design.includes("V5") ? (
              <FormSwitchTC
                name={"autoDetectLayout"}
                tDefault={"Layout Auto Detect"}
                tKey={"vestigingen.form.overige.label.autoDetectLayout"}
              />
            ) : null}
          </GridLegacy>
          <GridLegacy container spacing={1} style={{ maxWidth: 600 }}>
            {!design.includes("V4") && !design.includes("V5") ? (
              <>
                <FormSelectTC
                  name={"menuStyleDrank"}
                  options={menuStylenOptions}
                  tDefault={"Menu style drinken"}
                  tKey={"vestigingen.form.overige.label.menuStyleDrank"}
                />

                <FormSelectTC
                  name={"menuStyleDrankPCAuto"}
                  options={menuStylenOptions}
                  tDefault={"Menu style drinken (PC/A)"}
                  tKey={"vestigingen.form.overige.label.menuStyleDrankPCAuto"}
                />
              </>
            ) : null}
            {!design.includes("V5") ? (
              <FormSelectTC name={"autoOpenList"} options={autoOpenModeOptions} tKey={"Auto open menukaart"} />
            ) : null}
            {!design.includes("V5") ? (
              <FormSwitchTC
                name={"newWebInterface"}
                tDefault={"New webinterface"}
                tKey={"vestigingen.form.overige.label.newWebInterface"}
              />
            ) : null}{" "}
            {!design.includes("V5") ? (
              <FormSwitchTC
                name={"oldScrolling"}
                tDefault={"Old scrollbars"}
                tKey={"vestigingen.form.overige.label.oldScrolling"}
              />
            ) : null}
          </GridLegacy>
        </CardBody>
      </Card>

      <Card>
        <CardBody>
          <GridLegacy container spacing={1} style={{ maxWidth: 1200, marginBottom: 32 }}>
            <GridLegacy item xs={12}>
              <h3>
                <TranslationWrapper tDefault={"Afbeeldingen"} tKey={"vestigingen.form.branding.headers.images"} />
              </h3>
            </GridLegacy>
          </GridLegacy>
          <GridLegacy container style={{ marginBottom: 16 }}>
            <GridLegacy item xs={4}>
              <FormLabel>
                <TranslationWrapper tDefault={"Logo"} tKey={"vestigingen.form.branding.label.logoImage"} />
              </FormLabel>
              <FormFile name={"logoImage"} nullable={true} type={"image"} />
            </GridLegacy>
            <GridLegacy item xs={4}>
              <FormLabel>
                <TranslationWrapper tDefault={"Print logo"} tKey={"vestigingen.form.branding.label.printLogo"} />
              </FormLabel>
              <FormFile name={"printLogo"} nullable={true} type={"image"} />
            </GridLegacy>
          </GridLegacy>
          {!design.includes("V5") ? (
            <GridLegacy container spacing={1} style={{ maxWidth: 600, marginBottom: 16 }}>
              <GridLegacy item xs={4}>
                <FormLabel>
                  <TranslationWrapper tDefault={"Eten"} tKey={"vestigingen.form.branding.label.foodImg"} />
                </FormLabel>
                <ImageResolutionHint res={"78x78"} />
                <FormFile name={"foodImg"} nullable={true} type={"image"} />
              </GridLegacy>
              <GridLegacy item xs={4}>
                <FormLabel>
                  <TranslationWrapper
                    tDefault={"Achtergrond"}
                    tKey={"vestigingen.form.branding.label.backgroundImage"}
                  />
                </FormLabel>
                <FormFile name={"backgroundImage"} nullable={true} type={"image"} />
              </GridLegacy>
              <GridLegacy item xs={4}>
                <FormLabel>
                  <TranslationWrapper tDefault={"App Header"} tKey={"vestigingen.form.branding.label.appHeader"} />
                </FormLabel>
                <ImageResolutionHint res={"390x200"} />
                <FormFile
                  imgurl={
                    import.meta.env.VITE_AZURE_STORAGE +
                    "headers_footers/" +
                    vestigingId +
                    ".png?" +
                    Math.floor(Date.now() / 1000)
                  }
                  name={"appHeader"}
                  nullable={true}
                  type={"image"}
                />
              </GridLegacy>
            </GridLegacy>
          ) : null}
          {!design.includes("V5") ? (
            <GridLegacy container spacing={1} style={{ maxWidth: 600, marginBottom: 16 }}>
              <GridLegacy item xs={4}>
                <FormLabel>
                  <TranslationWrapper tDefault={"Drinken"} tKey={"vestigingen.form.branding.label.drinkImg"} />
                </FormLabel>
                <ImageResolutionHint res={"78x78"} />
                <FormFile name={"drinkImg"} nullable={true} type={"image"} />
              </GridLegacy>
              <GridLegacy item xs={4}>
                <FormLabel>
                  <TranslationWrapper
                    tDefault={"Achtergrond login"}
                    tKey={"vestigingen.form.branding.label.loginBackground"}
                  />
                </FormLabel>
                <FormFile name={"loginBackground"} nullable={true} type={"image"} />
              </GridLegacy>
              <GridLegacy item xs={4}>
                <FormLabel>
                  <TranslationWrapper tDefault={"App Footer"} tKey={"vestigingen.form.branding.label.appFooter"} />
                </FormLabel>
                <ImageResolutionHint res={"390x100"} />
                <FormFile
                  imgurl={
                    import.meta.env.VITE_AZURE_STORAGE +
                    "headers_footers/" +
                    vestigingId +
                    "_foot.png?" +
                    Math.floor(Date.now() / 1000)
                  }
                  name={"appFooter"}
                  nullable={false}
                  type={"image"}
                />
              </GridLegacy>
            </GridLegacy>
          ) : null}
        </CardBody>
      </Card>

      {!design.includes("V5") ? (
        <Card>
          <CardBody>
            <GridLegacy container spacing={1} style={{ maxWidth: 600, marginBottom: 16 }}>
              <GridLegacy item xs={12}>
                <h3>
                  <TranslationWrapper tDefault={"Branding"} tKey={"vestigingen.form.branding.headers.branding"} />
                </h3>
              </GridLegacy>

              <FormColorTC
                name={"fontColorInterface"}
                nullable={true}
                tDefault={"Tekst kleur 1"}
                tKey={"vestigingen.form.algemeen.label.fontColorInterface"}
              />
              <FormColorTC
                name={"bgColorInterface"}
                nullable={true}
                tDefault={"Achtergrond kleur 1"}
                tKey={"vestigingen.form.algemeen.label.bgColorInterface"}
              />
              <FormColorTC
                name={"fontColorApp"}
                nullable={true}
                tDefault={"Tekst kleur 2"}
                tKey={"vestigingen.form.algemeen.label.fontColorApp"}
              />
              <FormColorTC
                name={"bgColorApp"}
                nullable={true}
                tDefault={"Achtergrond Kleur 2"}
                tKey={"vestigingen.form.algemeen.label.bgColorApp"}
              />
              <FormColorTC
                name={"fontColorCustom"}
                nullable={true}
                tDefault={"Font color custom"}
                tKey={"vestigingen.form.algemeen.label.fontColorCustom"}
              />
              <FormColorTC
                name={"bgColor"}
                nullable={true}
                tDefault={"Achtergrond kleur 3"}
                tKey={"vestigingen.form.overige.label.bgColor"}
              />
            </GridLegacy>
          </CardBody>
        </Card>
      ) : null}

      <Card style={{ marginBottom: 16 }}>
        <CardBody>
          <GridLegacy container spacing={1}>
            <GridLegacy item xs={6}>
              <h3>
                <TranslationWrapper
                  tDefault={"Layout switches"}
                  tKey={"vestigingen.form.branding.headers.layoutSwitches"}
                />
              </h3>
            </GridLegacy>
            {!design.includes("V5") ? (
              <FormSwitchTC
                name={"showLangsel"}
                tDefault={"Show language selection"}
                tKey={"vestigingen.form.algemeen.label.showLangsel"}
              />
            ) : null}

            {theme.includes("V5") ? (
              <FormSelectTC
                fieldProps={({ value, onChange }) => ({
                  onChange: (e) => {
                    onChange(JSON.stringify(e.target.value));
                  },
                  value: value ? JSON.parse(value) : [],
                  multiple: true,
                })}
                name={"extra_settings__showLangselLanguages"}
                options={selectableFrontendLanguagesOptions}
                tDefault={"Available languages"}
                tKey={"vestigingen.form.algemeen.label.availableLanguages"}
              />
            ) : (
              <FormSelectTC
                fieldProps={({ value, onChange }) => ({
                  onChange: (e) => {
                    onChange(JSON.stringify(e.target.value));
                  },
                  value: value ? JSON.parse(value) : [],
                  multiple: true,
                })}
                name={"extra_settings__showLangselLanguages"}
                options={selectableFrontendLanguageOptionsv2}
                tDefault={"Available languages"}
                tKey={"vestigingen.form.algemeen.label.availableLanguages"}
              />
            )}

            {!design.includes("V5") ? (
              <FormFieldTwoColumns
                name={"extra_settings__useBrowserLanguage"}
                tDefault={"Use Browser Language"}
                tKey={"vestigingen.form.branding.label.useBrowserLanguage"}
              >
                <FormSwitch />
                <FormLabel>
                  <TranslationWrapper
                    tDefault={"Automatically switch to browser language of customer device "}
                    tKey={"vestigingen.form.branding.label.useBrowserLanguageDescription"}
                  />
                </FormLabel>
              </FormFieldTwoColumns>
            ) : null}
          </GridLegacy>
          {!design.includes("V5") ? (
            <GridLegacy container spacing={1}>
              <GridLegacy container item lg={3} md={4} sm={6} xs={12}>
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"showHistory"}
                  tDefault={"Toon geschiedenis"}
                  tKey={"vestigingen.form.overige.label.showHistory"}
                />
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"showReview"}
                  tDefault={"Toon review"}
                  tKey={"vestigingen.form.overige.label.showReview"}
                />
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"showBranding"}
                  tDefault={"Jamezz Branding"}
                  tKey={"vestigingen.form.overige.label.showBranding"}
                />
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"showTable"}
                  tDefault={"Show tafel"}
                  tKey={"vestigingen.form.overige.label.showTable"}
                />
              </GridLegacy>

              <GridLegacy item lg={3} md={4} sm={6} xs={12}>
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"optiesAsImages"}
                  tDefault={"Opties als plaatjes"}
                  tKey={"vestigingen.form.algemeen.label.optiesAsImages"}
                />
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"allowOptionSort"}
                  tDefault={"Allow options sort"}
                  tKey={"vestigingen.form.algemeen.label.allowOptionSort"}
                />
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"extra_settings__toggleOptions"}
                  tDefault={"Toggle opties"}
                  tKey={"vestigingen.form.algemeen.label.toggleOptions"}
                />
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"extra_settings__openFirstOption"}
                  tDefault={"Open first options"}
                  tKey={"vestigingen.form.algemeen.label.openFirstOption"}
                />
              </GridLegacy>

              <GridLegacy item lg={3} md={4} sm={6} xs={12}>
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"extra_settings__showSearchBar"}
                  tDefault={"Show Searchbar"}
                  tKey={"vestigingen.form.overige.label.showSearchBar"}
                />
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"showFilters"}
                  tDefault={"Show filters"}
                  tKey={"vestigingen.form.algemeen.label.showFilters"}
                />
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"extra_settings__showFood"}
                  tDefault={"Show food"}
                  tKey={"extra_settings.fields.label.showFood"}
                />
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"extra_settings__showDrinks"}
                  tDefault={"Show drinks"}
                  tKey={"extra_settings.fields.label.showDrinks"}
                />
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"extra_settings__disableHome"}
                  tDefault={"Disable home"}
                  tKey={"extra_settings.fields.label.disableHome"}
                />
              </GridLegacy>
              <GridLegacy item lg={3} md={4} sm={6} xs={12}>
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"extra_settings__showFooter"}
                  tDefault={"Show footer"}
                  tKey={"extra_settings.fields.label.showFooter"}
                />
                <FormSwitchTC
                  gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                  name={"extra_settings__openFirstCat"}
                  tDefault={"Open first category"}
                  tKey={"extra_settings.fields.label.openFirstCat"}
                />
              </GridLegacy>

              <GridLegacy container item xs={12}>
                <GridLegacy item xs={12}>
                  <h3>
                    <TranslationWrapper
                      tDefault={"Info screen"}
                      tKey={"vestigingen.form.branding.headers.infoScreen"}
                    />
                  </h3>
                </GridLegacy>
                <GridLegacy item lg={4} xs={12}>
                  <FormSwitchTC
                    gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                    name={"extra_settings__infoSplashButton"}
                    tDefault={"Show Info Button"}
                    tKey={"extra_settings.fields.label.infoSplashButton"}
                  />
                </GridLegacy>
                <GridLegacy item lg={4} xs={12}>
                  <FormSwitchTC
                    gridSizes={{ column1: { xs: 6 }, column2: { xs: 6 } }}
                    name={"extra_settings__infoSplashShowAlways"}
                    tDefault={"Show Info Screen Always on start"}
                    tKey={"extra_settings.fields.label.infoSplashShowAlways"}
                  />
                </GridLegacy>
                <GridLegacy item lg={4} xs={12}>
                  {!!extra_settings__infoSplashButton || !!extra_settings__infoSplashShowAlways ? (
                    <Tooltip
                      placement={"bottom"}
                      title={<TranslationWrapper tDefault={"Edit"} tKey={"global.jamezzTable.edit"} />}
                    >
                      <Button
                        color={"primary"}
                        onClick={() => {
                          setInfoTextDialogIsOpen(true);
                        }}
                        variant={"contained"}
                      >
                        <Edit />
                      </Button>
                    </Tooltip>
                  ) : null}
                </GridLegacy>
              </GridLegacy>
              <FormTextTC name={"appTarget"} tKey={"appTarget"} />
              <FormSelectTC
                name={"activeTheme"}
                options={activeThemesOptions}
                tDefault={"Thema"}
                tKey={"vestigingen.form.overige.label.activeTheme"}
              />
              <FormSwitchTC
                name={"instoreScreen"}
                tDefault={"Bestelzuil"}
                tKey={"vestigingen.form.zuil.label.instoreScreen"}
              />
            </GridLegacy>
          ) : null}
        </CardBody>
      </Card>

      {design.includes("V5") ? <BrandingV5 errors={errors} /> : null}

      <Card>
        <CardBody>
          <AuthenticationWrapper
            child={(write) => {
              return write ? (
                <TextField
                  multiline
                  style={{ width: "100%", padding: "8px" }}
                  value={typeof custom_data === "object" ? JSON.stringify(custom_data, null, 4) : ""}
                />
              ) : null;
            }}
            permissionKey={"custom_data"}
          />
        </CardBody>
      </Card>

      {infoTextDialogIsOpen ? (
        <InfoTextDialog
          onClose={() => {
            setInfoTextDialogIsOpen(false);
          }}
        />
      ) : null}
    </div>
  );
}

export default connect((state) => ({
  user: state.user,
}))(Branding);
